/**
 * The current Team Plan campaign window.
 *
 * @remarks
 * Shared by the signup sale banner and the signup price summary so both render the same date.
 */

// TODO: the campaign end date isn't exposed on selectedDiscount (subscriptionDiscountInterval
// describes the discounted-price billing duration, not the sale window) - hardcoded to match the
// Aug 18 - Sep 23 2026 campaign config in service-pricing until a real field is available.
export const SALE_END_DATE = new Date(2026, 8, 23); // months are 0-indexed
